export class RfqSessionExtendAuctionReasonType {
	public id: number;
	public name: string;

	constructor(rfqSessionExtendAuctionReasonType?: RfqSessionExtendAuctionReasonType) {
		Object.assign(this, rfqSessionExtendAuctionReasonType);
	}
}
